import React from 'react';

import viewport$ from 'mn-utils/browser/emitters/viewport';
import formatTime from 'mn-utils/formatTime';

import Col from '../../../dumb/Col/D';
import MenuForItem from '../../../dumb/Menu/ForItem';
import toEllipsisMiddle from '../../../../utils/toEllipsisMiddle';
import Tooltip from '../../../dumb/Tooltip/B';
import {apiV2RetailersList} from "../../../../api/admin/retailers";

import {
  pushLocation
} from '../../../../router';
import * as links from "../../../../constants/links";
import Caption from "../../../dumb/Caption/C";
import UpdateA from "../../../dumb/Button/UpdateA";

module.exports = require('../../../../utils/virtualOutputComponentProvider')({
  state: {
    viewport: viewport$.throttle(100),
  },
  rowHeight: 60,
  request: apiV2RetailersList,
  wrapper(render, setState, self) {
    function Item(props) {
      const {data} = props;

      return (
        <div
          className={`w layoutRow fhaS fvaC h60 bxzBorderBox rlv lh fw7 f12 c2 tl lts0em
                    (wmin130|w1/4|pt19|pr10|pb23|pl19)>1 bgF bb1 bsbS bcbE8E8E8`}
        >
          <div>
            <Tooltip className="fhaS" title={data.id}>
              {toEllipsisMiddle(data.id, 16)}
            </Tooltip>
          </div>
          <div>{data.name}</div>
          <div>{data.login}</div>
          <div>
            <div>{formatTime(data.last_invoice, '{dd} {mmm} {yyyy}')}</div>
            <MenuForItem items={[
              {
                name: 'Details',
                onClick() {
                  pushLocation({
                    path: `${links.LINK_ADMIN_RETAILER_DETAILS}/${data.id}`
                  })
                },
              },
            ]}/>
          </div>
          {/*<div>{upperFirst(data.account_status)}</div>*/}
          {/*<div>{data.overall_volume} {data.invoice_fiat_code}</div>*/}
          {/*<div>{data.monthly_volume} {data.invoice_fiat_code}</div>*/}
          {/*<div>{data.pending_invoice} {data.invoice_fiat_code}</div>*/}
          {/*<div>*/}
          {/*  <div>{formatTime(data.last_invoice, '{mmm}, {dd}')}</div>*/}
          {/*  <MenuForItem items={[*/}
          {/*    {*/}
          {/*      name: 'Send Invoice',*/}
          {/*      onClick() {*/}
          {/*        console.log('invoice!');*/}
          {/*      },*/}
          {/*    },*/}
          {/*  ]}/>*/}
          {/*</div>*/}
        </div>
      );
    }

    return (state, props) => {
      return (
        <div className="wmax912 w">
          <div className="layoutRow jcSB aiC">
            <Caption>Retailers</Caption>
            <UpdateA
              className="pl10"
              name="Update table"
              onClick={self.update}
            />
          </div>
          <div className="mt22">
            <div className="hmin360 h100vh-300@m2 rlv">
              <div className="abs sh sb10 st0 ov">
                <div className="abs s ov ovxA">
                  <div className="wmin912 rlv h">
                    <div className="w abs bgE layoutRow fhaS fvaC r9 ov w1/4>1">
                      <Col>Retailer ID</Col>
                      <Col>Retailer</Col>
                      <Col>Login</Col>
                      <Col>Created</Col>
                      {/*<Col>Status</Col>*/}
                      {/*<Col>Overall Volume</Col>*/}
                      {/*<Col>Monthly Volume</Col>*/}
                      {/*<Col>Pending Invoice</Col>*/}
                      {/*<Col>Last Invoice</Col>*/}
                    </div>
                    <div className="abs sh st45 sb ovH c0>.CircularProgress">
                      {render(Item)}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    };
  },
});
